// extracted by mini-css-extract-plugin
export default {"box":"Subheader_box__yL1RE","title":"Subheader_title__G9K2l"};